// EmptyState — the ONE empty / zero-data pattern (H1 fix, Playwright UX audit 02, 2026-07-03). Icon +
// title + optional description + optional CTA, centered in the page — so an empty page is never a bare
// one-line sentence over a blank canvas (the project-Overview "No child nodes at this level." case).
import { type ReactNode } from "react";

export interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({ icon, title, description, action }: EmptyStateProps): React.ReactElement {
  return (
    // role=status (Wave 4 §4.3): an empty result is a state change worth announcing politely to
    // screen readers — previously the region was silent. Visuals and wiring unchanged.
    <div role="status" className="flex flex-col items-center justify-center gap-3 px-6 py-20 text-center" data-app="empty-state">
      {icon && <div className="text-[var(--color-text-disabled)]">{icon}</div>}
      <div className="text-sm font-medium text-[var(--color-text-primary)]">{title}</div>
      {description && <p className="max-w-sm text-sm text-[var(--color-text-secondary)]">{description}</p>}
      {action && <div className="mt-1">{action}</div>}
    </div>
  );
}
